export default __webpack_public_path__ + "static/media/hero-max.f535646b.jpg";